// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__19oVW","content":"Consent_content__30Tjs","footer":"Consent_footer__zbsGc"};